import React, { useState } from 'react';
import { ContentBox } from "../ContentBox"
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleInput } from '../../Res/BaseInput';
import { SubmitButton } from '../../Res/BaseButton';
import Swal from 'sweetalert2';
import { ReqResumeAdd } from '../../../../item/ItemResume';
import { api_contractorResumeAdd, api_contractorResumeCheck } from '../../../../api/apiResume';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { setResume2Token, setVal2Token } from '../../../Login/Auth';
import { uuid } from '../../../../item/ItemTools';

export function ContractorResumeAdd({ setIsLoading }) {
    const [idNumber, setIdNumber] = useState("")
    const [birthday, setBirthday] = useState(moment(new Date()).add(-20, 'years').format('YYYY-MM-DD'))
    const [birthError, setBirthError] = useState(false)

    function toCheck() {
        if (birthError) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: '生日 格式有誤, 請確認月日為2位數',
            })
            return
        }
        /*
        if (!checkID(idNumber)) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: "身份証字號格式有誤, 請檢查",
            })
            return
        }
        */
        if (idNumber !== "" && birthday !== "") {
            setIsLoading(true)
            var mReqResumeAdd = new ReqResumeAdd({ idNumber, birthday })
            api_contractorResumeCheck({
                mReqResumeAdd,
                success: (jsonData) => {
                    console.log(jsonData)
                    setIsLoading(false)
                    if (jsonData.resumeId === undefined) {
                        Swal.fire({
                            type: 'success',
                            title: '提醒',
                            text: '是否新增外派員工？',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消 ',
                        }).then(function (result) {
                            if (result.value) {
                                toAdd()
                            } else if (result.dismiss === Swal.DismissReason.cancel) {
                                window.history.go(-1)
                            }
                        })
                    } else {
                        var tokenId = uuid(128, 64)
                        // setResume2Token(jsonData.resumeId, tokenId)
                        setVal2Token('resumeId', jsonData.resumeId, tokenId)
                        window.location.assign("/ContractorResumeDetail/" + tokenId);
                    }
                },
                failure: (err) => {
                    //console.log(err)
                    setIsLoading(false)
                    Swal.fire({
                        type: 'error',
                        title: '提醒',
                        text: err.message,
                    })
                }
            })

        } else {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: '身分證及生日 均不得為空',
            })
        }
    }

    function toAdd() {
        var mReqResumeAdd = new ReqResumeAdd({ idNumber, birthday })
        api_contractorResumeAdd({
            mReqResumeAdd,
            success: (jsonData) => {
                //console.log(jsonData)
                setIsLoading(false)
                //console.log(jsonData.tokenId)
                window.location.assign("/ContractorResumeEdit/" + jsonData.tokenId);
            },
            failure: (err) => {
                //console.log(err.message)
                setIsLoading(false)
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err.message,
                })
            }
        })
    }

    function checkID(id) {
        var tab = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
        var A1 = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3];
        var A2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5];
        var Mx = [9, 8, 7, 6, 5, 4, 3, 2, 1, 1];

        if (id.length !== 10) return false;
        var i = tab.indexOf(id.charAt(0));
        if (i === -1) return false;
        var sum = A1[i] + A2[i] * 9;

        for (i = 1; i < 10; i++) {
            var v = parseInt(id.charAt(i));
            if (isNaN(v)) return false;
            sum = sum + v * Mx[i];
        }
        if (sum % 10 !== 0) return false;
        return true;
    }


    const onChange = (jsDate, dateString) => {
        //console.log(jsDate)
        //console.log(dateString)
        if (dateString === "Invalid date") {
            setBirthError(true)
        } else {
            setBirthError(false)
            setBirthday(dateString)
        }
    }


    var baseTitle = "請先輸入檢驗資料"
    var baseContent =
        <div className="row">
            <div className="col-md-12">
                <SingleInput title={"身分證"} val={idNumber} action={setIdNumber} placeholder={"A123456789"} />
                {/**
                <SingleInput title={"生日"} val={birthday} action={setBirthday} placeholder={"1971/04/05"} />
                 */}

                <div class="col-md-3">
                    <p>生日</p>
                    <DatePickerInput
                        displayFormat='YYYY/MM/DD'
                        returnFormat='YYYY-MM-DD'
                        onChange={onChange}
                        value={birthday}
                        className='my-react-component'
                    />
                </div>
            </div>
            <SubmitButton action={toCheck} name="確定" isRight={true} />
        </div>
    return (
        <>
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}